import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types';

import type { AiSuggestionsPlugin } from '../aiSuggestionsPluginType';
import { thinkingPluginKey } from '../pm-plugins/thinking-plugin';

import type { StartThinkingAction } from './types';

export const startThinkingAction: (
	api: ExtractInjectionAPI<AiSuggestionsPlugin> | undefined,
) => StartThinkingAction =
	(api: ExtractInjectionAPI<AiSuggestionsPlugin> | undefined) => (): boolean => {
		return (
			api?.core?.actions.execute(({ tr }) => {
				tr.setMeta(thinkingPluginKey, {
					status: 'thinking',
				});
				return tr;
			}) || false
		);
	};
